import { motion } from "framer-motion";
import { ChevronRight, AlertTriangle, ArrowDown } from "lucide-react";

const specs = [
  "Advanced FMC / MCDU Simulation",
  "EICAS Primary & Secondary Display",
  "Boeing-specific AFCS & Autopilot",
  "Full Failure Injection",
  "FAA / EASA Compatible",
];

export function AnnouncementBanner() {
  const goToB737 = () => {
    document.querySelector("#b737")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };
  const goToContact = () => {
    document.querySelector("#contact")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      className="relative overflow-hidden border-y-2 cursor-pointer group"
      style={{ background: "oklch(0.97 0.01 25)", borderColor: "oklch(0.55 0.22 25 / 0.8)" }}
      onClick={goToB737}
    >
      {/* Diagonal stripe */}
      <div
        className="absolute inset-0 opacity-[0.04]"
        style={{
          backgroundImage: "repeating-linear-gradient(45deg, oklch(0.55 0.22 25) 0, oklch(0.55 0.22 25) 2px, transparent 0, transparent 50%)",
          backgroundSize: "12px 12px",
        }}
      />

      {/* Hover overlay */}
      <div
        className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none"
        style={{ background: "oklch(0.55 0.22 25 / 0.04)" }}
      />

      <div className="container mx-auto px-6 py-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center justify-between gap-6">

          {/* Left */}
          <div className="flex items-start gap-5">
            <motion.div
              animate={{ scale: [1, 1.06, 1] }}
              transition={{ duration: 1.8, repeat: Infinity }}
              className="flex-shrink-0 w-14 h-14 rounded-xl border-2 border-accent flex items-center justify-center"
              style={{ background: "oklch(0.55 0.22 25 / 0.12)" }}
            >
              <AlertTriangle className="w-7 h-7" style={{ color: "oklch(0.55 0.22 25)" }} />
            </motion.div>

            <div>
              <h2
                className="text-2xl md:text-3xl font-black leading-tight mb-1"
                style={{ fontFamily: "'Space Grotesk', sans-serif" }}
              >
                B737 MAX <span style={{ color: "oklch(0.28 0.09 240)" }}>Avionics</span>{" "}
                <span style={{ color: "oklch(0.55 0.22 25)" }}>— Now in Production!</span>
              </h2>
              <p className="text-muted-foreground text-sm">
                Available for ATO partners —{" "}
                <span
                  className="inline-flex items-center gap-1 font-semibold underline underline-offset-2 cursor-pointer"
                  style={{ color: "oklch(0.28 0.09 240)" }}
                >
                  see product details <ArrowDown className="w-3.5 h-3.5" />
                </span>
              </p>
            </div>
          </div>

          {/* Right — CTAs */}
          <div
            className="flex-shrink-0 flex flex-col sm:flex-row gap-3 items-center"
            onClick={e => e.stopPropagation()}
          >
            <button
              onClick={goToB737}
              className="flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-sm border-2 transition-all"
              style={{
                borderColor: "oklch(0.28 0.09 240)",
                color: "oklch(0.28 0.09 240)",
                background: "transparent",
              }}
              onMouseEnter={e => (e.currentTarget.style.background = "oklch(0.28 0.09 240 / 0.08)")}
              onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
            >
              View Product <ChevronRight className="w-4 h-4" />
            </button>

            <button
              onClick={goToContact}
              className="flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-sm transition-all"
              style={{
                background: "oklch(0.55 0.22 25)",
                color: "#fff",
                boxShadow: "0 4px 20px oklch(0.55 0.22 25 / 0.4)",
              }}
              onMouseEnter={e => (e.currentTarget.style.boxShadow = "0 6px 28px oklch(0.55 0.22 25 / 0.6)")}
              onMouseLeave={e => (e.currentTarget.style.boxShadow = "0 4px 20px oklch(0.55 0.22 25 / 0.4)")}
            >
              Request Information <ChevronRight className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Specs strip */}
        <div className="mt-5 pt-4 border-t border-accent/20 flex flex-wrap gap-x-6 gap-y-1">
          {specs.map(s => (
            <span key={s} className="flex items-center gap-2 text-xs font-medium text-muted-foreground">
              <span className="w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: "oklch(0.55 0.22 25)" }} />
              {s}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
